import { cn } from './lib/cn';

type DividerProps = {
    label?: string;
    className?: string;
};

export function Divider({ label, className }: DividerProps) {
    if (label) {
        return (
            <div className={cn('relative flex items-center', className)}>
                <div className='h-[1px] flex-grow bg-gray-300' />
                <span className='mx-2 flex-shrink text-sm text-gray-500'>{label}</span>
                <div className='h-[1px] flex-grow bg-gray-300' />
            </div>
        );
    }

    return <div className={cn('h-[1px] w-full bg-gray-300', className)} />;
}
